export const BREAKING_LENGTH = 1000;

export const addDots = (text: string) =>
  text.endsWith(".") ? `${text.trim()}..` : `${text.trim()}...`;

export const stripHtmlTags = (html: string) => {
  const localDiv = document.createElement("div");
  localDiv.innerHTML = html;

  return localDiv.textContent || "";
};

export const getShortText = (text: string, maxLength: number) => {
  if (stripHtmlTags(text).length <= maxLength) return text;

  const truncated = text.slice(0, maxLength);
  const lastSpace = truncated.lastIndexOf(" ");

  return lastSpace > 0 ? truncated.slice(0, lastSpace) : truncated;
};
